export default {
    account: 'Tài khoản',
    password: 'Mật khẩu',
    organizationName: 'Tên tổ chức',
    organizationAcronym: 'Tên viết tắt',
    fullAddress: 'Địa chỉ',
    houseNumber: 'Số nhà, tên đường',
    street: 'Đường',
    zipCode: 'Zip Code',
    adminAccount: 'Tài khoản admin',
    phoneNumber: 'Số điện thoại',
    organizationType: 'Loại tổ chức',
    expiredDate: 'Thời gian hết hạn',
    organizationBranchName: 'Tên chi nhánh',
    cameraName: 'Tên camera',
    streamUrl: 'Link stream',
    employeeCode: 'Mã nhân viên',
    firstName: 'Tên',
    lastName: 'Họ',
    birthday: 'Ngày sinh',
    type: 'Tên tài sản',
    deviceType: 'Loại tài sản',
    brand: 'Hãng',
    model: 'Mã',
    serialNumber: 'Số Serial',
    totalQuantity: 'Số lượng',
    importDate: 'Ngày nhập',
    supplier: 'Nhà cung cấp',
    fromDate: 'Ngày bắt đầu',
    toDate: 'Ngày kết thúc',
    assignDate: 'Ngày cấp',
    reason: 'Lí do',
    workShiftName: 'Tên ca',
    workDayOfWeek: 'Ngày làm việc',
    startHour: 'Thời gian bắt đầu',
    endHour: 'Thời gian kết thúc',
    bufferTime: 'Thời gian linh động',
    groupName: 'Tên nhóm',
    allowCheckInBefore: 'Cho phép check in trước',
    allowCheckInAfter: 'Cho phép check in sau',
    allowCheckOutBefore: 'Cho phép check out trước',
    allowCheckOutAfter: 'Cho phép check out sau',
    equipmentType: 'Tên vật dụng',
    dailyWorkName: 'Tên công việc',
    startDate: 'Ngày bắt đầu',
    endDate: 'Ngày kết thúc',
    dailyWorkDetailName: "Tên vật dụng",
    methodCheck: "Phương pháp",
    completionCriteria: "Yêu cầu công việc",
    placeDetailName: "Tên địa điểm",
    level: "Cấp độ ưu tiên",
    address: "Địa chỉ",
    areaDetailName: "Tên khu vực",
    nameRestrictedarea: "Tên sự kiện",
    fromHour: "Thời gian bắt đầu",
    toHour: "Thời gian kết thúc",
    date: "Ngày khiếu nại chấm công",
    newPassword: "Mật khẩu mới",
    cameraGroupName: "Tên nhóm",
    qrCode: "Mã QR",
    titleNotify: "Nhập tiêu đề",
    abbreviate: "Nhập tóm tắt",
    name: "Tên phòng họp",
    location: 'Địa điểm',
    reservationName: "Tên cuộc họp",
    purpose: "Mục đích",
    dateBegin: "Ngày họp",
    meetingRoom: "Phòng họp",
    participants: 'Người tham dự',
    timeKeepingType: 'Đối tác',
    oldPassWord: 'Mật khẩu cũ',
    newPassWord: 'Mật khẩu mới',
    reNewPassWord: 'Nhập lại mật khẩu mới',
    selectClass:'Chọn lớp học',
    title: 'Tiêu đề',
    email: 'Email',
    userName: 'Tên đăng nhập',
    salary: 'Lương',
    fullName: 'Tên đầy đủ',
    rePassword: 'Mật khẩu xác nhận',
    wifiName: 'Tên Wifi',
    CMT: 'CMT',
    emailModel: 'Email',
    numberPeople: 'Số người',
    camera: 'Camera',
    workshift: 'Ca làm việc',
    streetName: 'Tòa nhà, Tên đường',
    startTime: 'Thời gian bắt đầu',
    endTime: 'Thời gian kết thúc',
    className: 'Tên lớp',
    workshiftType: 'Loại ca làm việc',
    studentCode: 'Mã học viên',
    classRoom: 'Lớp học',
    positions: 'Chức vụ',
    description: 'Ghi chú',
    teacherMain: 'Giáo viên',
    employee: 'Nhân viên',
    listFilesEmployee: 'Danh sách dữ liệu nhân sự',
    student:'Học viên',

    //Library
    categoryTitle: 'Tên danh mục',
    categoryDescription: 'Mô tả',
    category: 'Danh mục',
    bookTitle: 'Tên sách',

    //Invoice
    paymentDate: 'Ngày thanh toán',
    typeInvoice: 'Loại phiếu thu',
    school: 'Trường',
    class: 'Lớp',
    student: 'Học sinh',
    amount: 'Tổng tiền',
    paid: 'Tiền đã đóng',
    status: 'Trạng thái',
    collector: 'Người thu phí',
    quantity: 'Số lượng',
    unitPrice: 'Đơn giá',
    deduction: 'Giảm trừ',
    dueDate: 'Hạn thanh toán',
    branch: 'Chi nhánh',

    startYear: 'Năm bắt đầu',
    endYear: 'Năm kết thúc',
    typeInterac: 'Loại',
    content: 'Nội dung',
    enterAddress: 'Vị trí',
    subject:'Môn học',
    grade: 'Khối',
    questionName: 'Câu hỏi',
    option0: 'Option 1',
    option1: 'Option 2',
    option2: 'Option 3',
    option3: 'Option 4',
    option4: 'Option 5',
    option5: 'Option 6',
    examName:'Tên đề thi',
    examTime:'Thời gian làm bài thi',
    points:'Điểm',
    Level:'Mức độ',
    timeStart:'Ngày bắt đầu',
    hourStart:'Giờ bắt đầu',
    timeEnd:'Ngày kết thúc',
    hourEnd:'Giờ kết thúc',
    topicName:'Tên bộ đề',
    semester:'Học kì'
}
